import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Switch, Route, Redirect } from 'react-router-dom';

import ReturnsList from './ReturnsList';
import ReturnsDetail from './ReturnsDetail';

import { loadReturns } from '../../actions/returns';
import { getReturnableDevices } from '../../actions/devices';
import {
  RETURNS_ORDER_DETAIL,
  RETURNS_ORDER_STATUS,
  RETURNS_SELECT_DEVICE,
  RETURNS_DOWNTIME,
} from '../../helpers/routes';
import { returnsDisabled } from '../../helpers/returns';
import LoadingWrapper from '../../components/LoadingWrapper';

class Returns extends Component {
  componentDidMount() {
    const { handleLoadDsmToken, handleLoadDevices } = this.props;
    handleLoadDsmToken();
    handleLoadDevices();
  }

  render() {
    const { returns, loading } = this.props;

    if (loading) {
      return <LoadingWrapper />;
    }

    if (returnsDisabled()) {
      return <Redirect to={RETURNS_DOWNTIME} />;
    }

    if (!returns.length) {
      return <Redirect to={RETURNS_SELECT_DEVICE} />;
    }

    return (
      <Switch>
        <Route exact path={RETURNS_ORDER_STATUS} component={ReturnsList} />
        <Route exact path={RETURNS_ORDER_DETAIL} component={ReturnsDetail} />
      </Switch>
    );
  }
}

const mapStateToProps = ({ returns: { loading, returns = [] } }) => ({
  returns,
  loading,
});

const mapDispatchToProps = dispatch => ({
  handleLoadDsmToken: bindActionCreators(loadReturns, dispatch),
  handleLoadDevices: bindActionCreators(getReturnableDevices, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Returns);
